const React = require('react');

/* eslint-disable */
module.exports = (props) => {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      className={'dB fillCT>path ' + (props.className || '')}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24ZM13.1355 13.8063L13.4892 6.06061H10.5183L10.8808 13.8063H13.1355ZM13.1355 15.893C12.829 15.5747 12.4517 15.4156 12.0037 15.4156C11.5675 15.4156 11.1903 15.5747 10.872 15.893C10.5595 16.2055 10.4033 16.5798 10.4033 17.016C10.4033 17.4522 10.5595 17.8295 10.872 18.1478C11.1903 18.4602 11.5675 18.6164 12.0037 18.6164C12.4517 18.6164 12.829 18.4602 13.1355 18.1478C13.448 17.8295 13.6042 17.4522 13.6042 17.016C13.6042 16.5798 13.448 16.2055 13.1355 15.893Z"
      />
    </svg>
  );
};
